import i18n from '@monolith/legacy/services/i18n';

export const getFormattedFrom = (brand) => {
  if (!brand.business.user_first_name) {
    return i18n.global.t('{brand} by Ankorstore', { brand: brand.name });
  }
  const from = [brand.business.user_first_name];
  if (brand.business.user_last_name) {
    from.push(brand.business.user_last_name);
  }
  from.push(String(i18n.global.t('From')).toLowerCase(), brand.name);

  return from.join(' ');
};

export const getFormattedFromSenderName = (brand): string => {
  if (!brand?.business?.user_first_name) {
    return '';
  }

  const from = [brand.business.user_first_name];
  if (brand.business.user_last_name) {
    from.push(brand.business.user_last_name);
  }
  return from.join(' ');
};
